<template>
  <div>
    <div class="d-inline-flex">
      <luci-btn-icon :config="addCategoryBtnConfig" @callback="$router.push({ name: 'CategoryCreate' })"></luci-btn-icon>
      <luci-btn-icon :config="refreshTableBtnConfig" @callback="getItems({ sortBy })"></luci-btn-icon>
    </div>

    <v-alert v-if="error" :value="true" color="error" icon="error" class="error-container">
      <span class="error-span luci-text white--text">{{ error }}</span>
    </v-alert>

    <luci-table :loading="isLoading || deleteLoading" :config="categoryListConfig" @edit-row-callback="editCategory" @delete-row-callback="openDeleteModal" @sort-by-callback="sortCallback"></luci-table>
    <paging name="category-list" :view="view" @page="gotoPage"></paging>

    <confirm-modal
      :open="showDeleteModal"
      @yes-callback="deleteCategory"
      @no-callback="closeDeleteModal"
      :title="'Delete category?'"
      :message="'Do you want to delete category: <b>'+ this.categoryToDelete.name +'</b> ?'"
    ></confirm-modal>

    <message-modal :open="showMsgModal" @ok-callback="showMsgModal = false"></message-modal>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { split } from 'lodash'

import ConfirmModal from '../modal/ConfirmModal'
import MessageModal from '../modal/MessageModal'
import Paging from '../shared/paging/Paging'
import variables from '../../helpers/variables'

export default {
  computed: {
    ...mapGetters({
      error: 'category/list/error',
      items: 'category/list/items',
      isLoading: 'category/list/isLoading',
      view: 'category/list/view',
      tableItems: 'category/list/tableItems',
      deleteError: 'category/del/error',
      deleteLoading: 'category/del/isLoading'
    }),
    categoryListConfig () {
      return {
        title: 'Categories',
        showSearch: true,
        items: this.tableItems,
        loading: this.isLoading,
        headers: [
          { text: 'Name', value: 'data.name', sortable: true },
          { text: 'Description', value: 'data.description' },
          { text: 'Actions', value: 'actions' }
        ],
        pagination: { sortBy: 'data.name' },
        serverSorting: true,
        showButtonEdit: true,
        showButtonDelete: true,
        hideActions: true
      }
    }
  },
  components: {
    ConfirmModal, MessageModal, Paging
  },
  data () {
    return {
      showMsgModal: false,
      showDeleteModal: false,
      categoryToDelete: {},
      addCategoryBtnConfig: {
        type: 'button',
        name: 'add-category-btn',
        primary: true,
        icon: true,
        iconType: 'add',
        tooltip: 'Add a new category'
      },
      refreshTableBtnConfig: variables.refreshBtnIconOptions,
      sortBy: null
    }
  },
  created () {
    this.getItems({ sortBy: this.sortBy })
  },
  methods: {
    ...mapActions({
      getItems: 'category/list/getItems',
      delete: 'category/del/del'
    }),
    editCategory (item) {
      this.$router.push({ name: 'CategoryUpdate', params: { id: item['@id'] } })
    },
    openDeleteModal (item) {
      this.showDeleteModal = true
      this.categoryToDelete = item
    },
    closeDeleteModal () {
      this.showDeleteModal = false
      this.categoryToDelete = {}
    },
    deleteCategory () {
      this.showDeleteModal = false
      this.delete(this.categoryToDelete).then(() => {
        if (!this.deleteError) {
          this.categoryToDelete = {}
          this.getItems({ sortBy: this.sortBy })
        } else {
          this.showMsgModal = true
        }
      })
    },
    gotoPage (page) {
      this.getItems({ sortBy: this.sortBy, page: this.view['hydra:' + page] })
    },
    sortCallback (column, descending) {
      const field = split(column, '.')[1]
      const direction = descending ? 'desc' : 'asc'
      this.sortBy = `order[${field}]=${direction}`
      this.getItems({ sortBy: this.sortBy })
    }
  }
}
</script>
